import { JsonObject, JsonProperty } from 'json2typescript'
import Address from '../Address'
import CoInsuranceRule from '../CoInsuranceRule'
import CustomList from '../CustomList'
import Risk from '../Risk'
import VehicleDriver from './VehicleDriver'
import VehicleProposer from './VehicleProposer'
import VehicleRiskVehicle from './VehicleRiskVehicle'

@JsonObject('VehicleRisk')
export default class VehicleRisk extends Risk {
  @JsonProperty('proposer', VehicleProposer)
  proposer: VehicleProposer

  @JsonProperty('vehicles', [VehicleRiskVehicle])
  vehicles: VehicleRiskVehicle[]

  @JsonProperty('vehicleDrivers', [VehicleDriver])
  vehicleDrivers: VehicleDriver[]

  constructor(
    id = 0,
    effectiveDate = new Date(),
    address = new Address(),
    businessSource = new CustomList(),
    coInsuranceRule = new CoInsuranceRule(),
    proposer = new VehicleProposer(),
    vehicles: VehicleRiskVehicle[] = [],
    vehicleDrivers: VehicleDriver[] = [],
  ) {
    super(id, 'Vehicle', effectiveDate, address, businessSource, coInsuranceRule)
    this.proposer = proposer
    this.vehicles = vehicles
    this.vehicleDrivers = vehicleDrivers
  }
}
